import type {TeamInsightsActionItemCategory} from "@/shared/timr";

export function categoryLabel(category: TeamInsightsActionItemCategory): string {
	return messages[`reports.teamInsights.category.${category}`] ?? category;
}

export function categoryLabelClass(category: TeamInsightsActionItemCategory): string {
	switch (category) {
		case "TIME_ACCOUNT":
			return "label-danger";
		case "VACATION_AND_ABSENCE":
			return "label-info";
		case "WORKTIME_VALIDATIONS":
			return "label-warning";
		default:
			return "label-default";
	}
}
